import api from './index.js'

/**
 * 상품구매 인출 목록/상세 (payment.product_code 있는 건만, 호가 제외)
 */
export function getProductWithdrawalList(params) {
  return api.get('/api/v1/product-withdrawal', { params })
}

export function getProductWithdrawalDetail(paymentCode) {
  return api.get(`/api/v1/product-withdrawal/${paymentCode}`)
}

/** 인출완료 처리 (통합원장 withdrawn_yn / withdrawn_dt) */
export function putProductWithdrawalWithdrawn(paymentCode) {
  return api.put(`/api/v1/product-withdrawal/${paymentCode}/withdrawn`)
}
